/**
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2025 Pearson Education, Inc. All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Pearson Education, Inc.  The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S. and Foreign Patents,
 * patent applications, and are protected by trade secret or copyright law.
 * Dissemination of this information, reproduction of this material, and copying or distribution of this software
 * is strictly forbidden unless prior written permission is obtained
 * from Pearson Education, Inc.
 */

/**
 * PublishButton - Externalized publish button component
 *
 * @file PublishButton.jsx
 * @author Satyaki Bose
 * @since 0.0.2
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import mixins from '../../assets/styles/mixins.scss';
import SafeButtonWrapper from './SafeButtonWrapper';

const useStyles = makeStyles(() => ({
  publishButtonCTA: {
    backgroundColor: mixins.amethystColor,
    color: mixins.chalkWhiteFont,
    fontFamily: mixins.fontFamilyPlusSans,
    fontSize: mixins.fontSize16,
    fontWeight: mixins.fontWeight500,
    lineHeight: '16px',
    borderRadius: 1000,
    textTransform: 'none',
    padding: '8px 16px',
    height: 40,
    marginLeft: '10px',
    '&:hover': {
      backgroundColor: mixins.amethystColor,
      color: mixins.chalkWhiteFont,
      opacity: 0.9
    },
    '&:disabled': {
      backgroundColor: mixins.greyScaleColor,
      color: mixins.chalkWhiteFont,
      opacity: 0.5
    }
  }
}));

const PublishButton = ({ onClick, disabled, label, isLoading }) => {
  const classes = useStyles();

  return (
    <SafeButtonWrapper isLoading={isLoading}>
      <Button
        variant="contained"
        onClick={onClick}
        disabled={disabled}
        className={classes.publishButtonCTA}
      >
        {label}
      </Button>
    </SafeButtonWrapper>
  );
};

PublishButton.propTypes = {
  onClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
  label: PropTypes.string.isRequired,
  isLoading: PropTypes.bool
};

PublishButton.defaultProps = {
  disabled: false,
  isLoading: null
};

export default PublishButton;

